<template>
  <div class="columns is-centered">
    <section class="section">
      <div class="box">
        <form @submit.prevent="generateReport">
          <div class="field">
            <div class="field-body">
              <div class="field-label">
                <label class="label">Report Name</label>
              </div>
              <div class="field">
                <p class="control">
                  <input
                    autofocus
                    required
                    class="input"
                    type="text"
                    id="reportName"
                    v-model="reportName"
                  />
                </p>
              </div>
              <div class="field-label">
                <label class="label">Calendar User</label>
              </div>
              <span class="select" v-if="hasCalendarUsers">
                <select required v-model="calUser">
                  <option disabled value="disabled">Please select one</option>
                  <option
                    v-for="calendarUser in orderedCalendarUsers()"
                    v-bind:value="calendarUser.record_id"
                    :key="calendarUser.calendar_name"
                    >{{ calendarUser.calendar_name }}</option
                  >
                </select>
              </span>
            </div>
          </div>
          <div class="field">
            <input required type="date" />
          </div>
          <div class="field">
            <button
              class="button is-block is-info is-medium is-fullwidth"
              type="submit"
            >
              Generate Report
            </button>
          </div>
        </form>
      </div>
    </section>
  </div>
</template>

<script>
import bulmaCalendar from "bulma-calendar/dist/js/bulma-calendar.min.js";
import "bulma-calendar/dist/css/bulma-calendar.min.css";
import "bulma-switch/dist/css/bulma-switch.min.css";
import date from "date-and-time";
import _ from "lodash";

export default {
  props: {
    account: Object,
    default: () => {},
    required: true
  },
  components: {},
  data() {
    return {
      reportName: "",
      startDate: "",
      endDate: "",
      error: {
        iCalendar: false
      },
      calendarUsers: [],
      calUser: "disabled",
      reportNameRequired: false
    };
  },
  methods: {
    generateReport: function() {
      this.convertDates();
      this.syncCalendar();
    },
    getCalendarUsers: function() {
      this.$http
        .get(process.env.VUE_APP_API_URL + "/teams/calendaruser")
        .then(httpResponse => {
          if (httpResponse.data.calendar_users) {
            this.calendarUsers = httpResponse.data.calendar_users;
          }
        })
        .catch(httpError => {
          if (httpError.response.status == 401) {
            localStorage.removeItem("token");
            this.$router.push("/");
          }
        });
    },
    syncCalendar: function() {
      let data = {
        report_name: this.reportName,
        calendar_user: this.calUser,
        start_date: this.startDate,
        end_date: this.endDate,
        mileage_reimbursement: process.env.VUE_APP_IRS_MILEAGE_RATE
      };
      this.$http
        .put(process.env.VUE_APP_API_URL + "/teams/calendarsync", data)
        .then(response => {
          this.$nextTick(() => {
            this.$emit("report-id", response.data.report_id);
          });
        })
        .catch(httpError => {
          if (httpError.response) {
            switch (httpError.response.data.error) {
              default:
                this.error.iCalendar = true;
            }

            if (httpError.response.status == 500) {
              this.error.iCalendar = true;
            }
          }
        });
    },
    convertDates: function() {
      this.startDate = date.format(this.startDate, "MM/DD/YYYY");
      this.endDate = date.format(this.endDate, "MM/DD/YYYY");
    },
    orderedCalendarUsers: function() {
      return _.sortBy(this.calendarUsers, ["calendar_name", "record_id"]);
    }
  },
  created: function() {
    this.getCalendarUsers();
  },
  mounted() {
    const calendar = bulmaCalendar.attach(this.$refs.calendarTrigger, {
      startDate: this.date,
      showHeader: true,
      showFooter: true,
      isRange: true,
      labelFrom: "Start Date",
      labelTo: "End Date",
      displayMode: "inline"
    })[0];
    calendar.on(
      "date:selected",
      e => (this.startDate = e.start) && (this.endDate = e.end)
    );
  },
  computed: {
    hasCalendarUsers: function() {
      return this.calendarUsers.length > 0;
    },
    niceDate() {
      if (this.date) {
        return this.date.toLocaleDateString();
      }
    }
  }
};
</script>

<style scoped>
.switch[type="checkbox"] + label::before {
  background: #209cee;
}

.select select {
  text-rendering: auto !important;
}
</style>
